"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleAvailableOptionsFields = exports.MONTH_INDEX = exports.SCHEDULE_ROW_INDEX = exports.SCHEDULE_ROW = exports.HEALTH_CHECK_EXTENDED_DAY_OF_WEEK = exports.HEALTH_CHECK_DAY_NUMBER_IN_MONTH = exports.EXTENDED_DAY_NUMBER_IN_MONTH = exports.DAY_NUMBER_IN_MONTH = exports.HEALTH_CHECK_MONTH_OF_YEAR = exports.MONTH_OF_YEAR = exports.DAY_INDEX = exports.DAILY_SCHEDULE_KINDS = void 0;
require("../../../core");
var DAILY_SCHEDULE_KINDS;
(function (DAILY_SCHEDULE_KINDS) {
    DAILY_SCHEDULE_KINDS["everyday"] = "everyday";
    DAILY_SCHEDULE_KINDS["weekDays"] = "weekDays";
    DAILY_SCHEDULE_KINDS["selectedDays"] = "selectedDays";
})(DAILY_SCHEDULE_KINDS = exports.DAILY_SCHEDULE_KINDS || (exports.DAILY_SCHEDULE_KINDS = {}));
var DAY_INDEX;
(function (DAY_INDEX) {
    DAY_INDEX[DAY_INDEX["sunday"] = 0] = "sunday";
    DAY_INDEX[DAY_INDEX["monday"] = 1] = "monday";
    DAY_INDEX[DAY_INDEX["tuesday"] = 2] = "tuesday";
    DAY_INDEX[DAY_INDEX["wednesday"] = 3] = "wednesday";
    DAY_INDEX[DAY_INDEX["thursday"] = 4] = "thursday";
    DAY_INDEX[DAY_INDEX["friday"] = 5] = "friday";
    DAY_INDEX[DAY_INDEX["saturday"] = 6] = "saturday";
})(DAY_INDEX = exports.DAY_INDEX || (exports.DAY_INDEX = {}));
var MONTH_OF_YEAR;
(function (MONTH_OF_YEAR) {
    MONTH_OF_YEAR["january"] = "january";
    MONTH_OF_YEAR["february"] = "february";
    MONTH_OF_YEAR["march"] = "march";
    MONTH_OF_YEAR["april"] = "april";
    MONTH_OF_YEAR["may"] = "may";
    MONTH_OF_YEAR["june"] = "june";
    MONTH_OF_YEAR["july"] = "july";
    MONTH_OF_YEAR["august"] = "august";
    MONTH_OF_YEAR["september"] = "september";
    MONTH_OF_YEAR["october"] = "october";
    MONTH_OF_YEAR["november"] = "november";
    MONTH_OF_YEAR["december"] = "december";
})(MONTH_OF_YEAR = exports.MONTH_OF_YEAR || (exports.MONTH_OF_YEAR = {}));
var HEALTH_CHECK_MONTH_OF_YEAR;
(function (HEALTH_CHECK_MONTH_OF_YEAR) {
    HEALTH_CHECK_MONTH_OF_YEAR["everyMonth"] = "everyMonth";
    HEALTH_CHECK_MONTH_OF_YEAR["everySelectedMonth"] = "everySelectedMonth";
})(HEALTH_CHECK_MONTH_OF_YEAR = exports.HEALTH_CHECK_MONTH_OF_YEAR || (exports.HEALTH_CHECK_MONTH_OF_YEAR = {}));
var DAY_NUMBER_IN_MONTH;
(function (DAY_NUMBER_IN_MONTH) {
    DAY_NUMBER_IN_MONTH["first"] = "first";
    DAY_NUMBER_IN_MONTH["second"] = "second";
    DAY_NUMBER_IN_MONTH["third"] = "third";
    DAY_NUMBER_IN_MONTH["fourth"] = "fourth";
    DAY_NUMBER_IN_MONTH["last"] = "last";
    DAY_NUMBER_IN_MONTH["onDay"] = "onDay";
})(DAY_NUMBER_IN_MONTH = exports.DAY_NUMBER_IN_MONTH || (exports.DAY_NUMBER_IN_MONTH = {}));
var EXTENDED_DAY_NUMBER_IN_MONTH;
(function (EXTENDED_DAY_NUMBER_IN_MONTH) {
    EXTENDED_DAY_NUMBER_IN_MONTH["onLastDay"] = "OnLastDay";
})(EXTENDED_DAY_NUMBER_IN_MONTH = exports.EXTENDED_DAY_NUMBER_IN_MONTH || (exports.EXTENDED_DAY_NUMBER_IN_MONTH = {}));
var HEALTH_CHECK_DAY_NUMBER_IN_MONTH;
(function (HEALTH_CHECK_DAY_NUMBER_IN_MONTH) {
    HEALTH_CHECK_DAY_NUMBER_IN_MONTH["first"] = "first";
    HEALTH_CHECK_DAY_NUMBER_IN_MONTH["second"] = "second";
    HEALTH_CHECK_DAY_NUMBER_IN_MONTH["third"] = "third";
    HEALTH_CHECK_DAY_NUMBER_IN_MONTH["fourth"] = "fourth";
    HEALTH_CHECK_DAY_NUMBER_IN_MONTH["last"] = "last";
    HEALTH_CHECK_DAY_NUMBER_IN_MONTH["every"] = "every";
})(HEALTH_CHECK_DAY_NUMBER_IN_MONTH = exports.HEALTH_CHECK_DAY_NUMBER_IN_MONTH || (exports.HEALTH_CHECK_DAY_NUMBER_IN_MONTH = {}));
var HEALTH_CHECK_EXTENDED_DAY_OF_WEEK;
(function (HEALTH_CHECK_EXTENDED_DAY_OF_WEEK) {
    HEALTH_CHECK_EXTENDED_DAY_OF_WEEK["scheduledDay"] = "scheduledDay";
})(HEALTH_CHECK_EXTENDED_DAY_OF_WEEK = exports.HEALTH_CHECK_EXTENDED_DAY_OF_WEEK || (exports.HEALTH_CHECK_EXTENDED_DAY_OF_WEEK = {}));
var SCHEDULE_ROW;
(function (SCHEDULE_ROW) {
    SCHEDULE_ROW["first"] = "first";
    SCHEDULE_ROW["second"] = "second";
    SCHEDULE_ROW["third"] = "third";
})(SCHEDULE_ROW = exports.SCHEDULE_ROW || (exports.SCHEDULE_ROW = {}));
var SCHEDULE_ROW_INDEX;
(function (SCHEDULE_ROW_INDEX) {
    SCHEDULE_ROW_INDEX[SCHEDULE_ROW_INDEX["first"] = 0] = "first";
    SCHEDULE_ROW_INDEX[SCHEDULE_ROW_INDEX["second"] = 1] = "second";
    SCHEDULE_ROW_INDEX[SCHEDULE_ROW_INDEX["third"] = 2] = "third";
})(SCHEDULE_ROW_INDEX = exports.SCHEDULE_ROW_INDEX || (exports.SCHEDULE_ROW_INDEX = {}));
var MONTH_INDEX;
(function (MONTH_INDEX) {
    MONTH_INDEX[MONTH_INDEX["january"] = 0] = "january";
    MONTH_INDEX[MONTH_INDEX["february"] = 1] = "february";
    MONTH_INDEX[MONTH_INDEX["march"] = 2] = "march";
    MONTH_INDEX[MONTH_INDEX["april"] = 3] = "april";
    MONTH_INDEX[MONTH_INDEX["may"] = 4] = "may";
    MONTH_INDEX[MONTH_INDEX["june"] = 5] = "june";
    MONTH_INDEX[MONTH_INDEX["july"] = 6] = "july";
    MONTH_INDEX[MONTH_INDEX["august"] = 7] = "august";
    MONTH_INDEX[MONTH_INDEX["september"] = 8] = "september";
    MONTH_INDEX[MONTH_INDEX["october"] = 9] = "october";
    MONTH_INDEX[MONTH_INDEX["november"] = 10] = "november";
    MONTH_INDEX[MONTH_INDEX["december"] = 11] = "december";
})(MONTH_INDEX = exports.MONTH_INDEX || (exports.MONTH_INDEX = {}));
var ScheduleAvailableOptionsFields;
(function (ScheduleAvailableOptionsFields) {
    ScheduleAvailableOptionsFields["time"] = "time";
    ScheduleAvailableOptionsFields["dayOfWeek"] = "dayOfWeek";
    ScheduleAvailableOptionsFields["monthOfYear"] = "monthOfYear";
    ScheduleAvailableOptionsFields["dayNumberInMonth"] = "dayNumberInMonth";
})(ScheduleAvailableOptionsFields = exports.ScheduleAvailableOptionsFields || (exports.ScheduleAvailableOptionsFields = {}));
//# sourceMappingURL=common.js.map